import { render, staticRenderFns } from "./contact-button.vue?vue&type=template&id=afde795e&scoped=true"
import script from "./contact-button.vue?vue&type=script&lang=ts"
export * from "./contact-button.vue?vue&type=script&lang=ts"
import style0 from "./contact-button.vue?vue&type=style&index=0&id=afde795e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afde795e",
  null
  
)

export default component.exports